export type ProfileComparisonDimension =
  | 'overall'
  | 'coreCompetencies'
  | 'hardSkills'
  | 'tools'
  | 'domainKnowledge'
  | 'softSkills'
  | 'responsibilities';

export type ProfileComparisonEffortLevel = 'low' | 'moderate' | 'high';

export type ProfileComparisonDeltaVariant = 'up' | 'down' | 'flat';

export type ProfileComparisonVerdictState = 'aLeads' | 'bLeads' | 'tied';

export const PROFILE_COMPARISON_DIMENSIONS: ProfileComparisonDimension[] = [
  'overall',
  'coreCompetencies',
  'hardSkills',
  'tools',
  'domainKnowledge',
  'softSkills',
  'responsibilities',
];

export interface ProfileComparisonSummary {
  profileId: string;
  overallScore: number | null;
  seniority: string | null;
  department: string | null;
  targetRole: string | null;
}

export interface ProfileComparisonVerdict {
  leadingProfileId: string | null;
  dimensionsLed: number;
  isTied: boolean;
}

export interface ProfileComparisonDimensionDelta {
  dimension: ProfileComparisonDimension;
  scoreA: number | null;
  scoreB: number | null;
  deltaA: number | null;
  deltaB: number | null;
}

export interface ProfileComparisonGapBreakdown {
  onlyProfileA: string[];
  onlyProfileB: string[];
  shared: string[];
}

export interface ProfileComparisonDevelopmentEffortItem {
  gapCount: number;
  effortLevel: ProfileComparisonEffortLevel;
}

export interface ProfileComparisonDevelopmentEffort {
  profileA: ProfileComparisonDevelopmentEffortItem;
  profileB: ProfileComparisonDevelopmentEffortItem;
}

export interface ProfileComparisonResult {
  profileA: ProfileComparisonSummary;
  profileB: ProfileComparisonSummary;
  roleMismatch: boolean;
  verdict: ProfileComparisonVerdict;
  dimensionDeltas: ProfileComparisonDimensionDelta[];
  gapBreakdown: ProfileComparisonGapBreakdown;
  developmentEffort: ProfileComparisonDevelopmentEffort;
}
